import { render } from "./Captcha.vue?vue&type=template&id=d7c04e90"
import script from "./Captcha.ts?vue&type=script&lang=js&external"
export * from "./Captcha.ts?vue&type=script&lang=js&external"

import "./Captcha.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__